import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pluralSingular',
    standalone: false
})
export class PluralSingularPipe implements PipeTransform {
    transform(count: number, singularText: string, pluralText: string = null): string {
        const pluralWord = pluralText ? pluralText : `${singularText}s`;
        return count === 1 ? `${count} ${singularText}` : `${count} ${pluralWord}`;
    }
}
